import { formatDate } from './dataAdapter.js';

// Callback for when URL changes via popstate
let onRouteChange = null;

/**
 * Initialize the router with a callback for route changes
 */
export function initRouter(callback) {
  onRouteChange = callback;
  window.addEventListener('popstate', handlePopState);
}

/**
 * Handle browser back/forward navigation
 */
function handlePopState() {
  if (onRouteChange) {
    const date = getDateFromLocation();
    onRouteChange(date);
  }
}

/**
 * Parse the current URL to extract the date
 * Returns Date object or null if not a valid date route
 */
export function getDateFromLocation() {
  const path = window.location.pathname;
  const match = path.match(/^\/d\/(\d{4}-\d{2}-\d{2})$/);

  if (match) {
    const [year, month, day] = match[1].split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  return null;
}

/**
 * Update the URL to reflect the given date
 * @param {Date} date - The date to show in URL
 * @param {boolean} replace - If true, use replaceState; otherwise pushState
 */
export function updateUrlForDate(date, replace = false) {
  const dateStr = formatDate(date);
  const newPath = `/d/${dateStr}`;

  if (window.location.pathname === newPath) {
    return; // Already at this URL
  }

  if (replace) {
    window.history.replaceState({ date: dateStr }, '', newPath);
  } else {
    window.history.pushState({ date: dateStr }, '', newPath);
  }
}
